import { LanguageItem } from '../interfaces/interfaces';

const customerNumberKey: string = 'customerNumber';
const lastPhoneConfirmTimeKey: string = 'lastPhoneConfirmTime';
const lastEmailConfirmTimeKey: string = 'lastEmailConfirm';
const languageKey: string = 'language';
const redirectAfterLoginKey: string = 'redirectAfterLogin';

export const setCustomerNumber = (customerNo: number) => {
  localStorage.setItem(customerNumberKey, customerNo.toString());
};

export const getCustomerNumber = () => {
  var customerNoString = localStorage.getItem(customerNumberKey);
  return customerNoString ? +customerNoString : 0;
};

export const setLastPhoneConfirmTime = (time: string) => {
  localStorage.setItem(lastPhoneConfirmTimeKey, time);
};

export const getLastPhoneConfirmTime = () => {
  return localStorage.getItem(lastPhoneConfirmTimeKey);
};

export const removeLastPhoneConfirm = () => {
  localStorage.removeItem(lastPhoneConfirmTimeKey);
};

export const setLastEmailConfirm = (time: string) => {
  localStorage.setItem(lastEmailConfirmTimeKey, time);
};

export const getLastEmailConfirm = () => {
  return localStorage.getItem(lastEmailConfirmTimeKey);
};

export const removeLastEmailConfirm = () => {
  return localStorage.removeItem(lastEmailConfirmTimeKey);
};

export const setLanguage = (lang: LanguageItem) => {
  localStorage.setItem(languageKey, lang.key);
};

export const getLanguage = () => {
  return localStorage.getItem(languageKey);
};

export const setRedirectAfterLogin = (url: string) => {
  localStorage.setItem(redirectAfterLoginKey, url);
};

export const getRedirectAfterLogin = () => {
  return localStorage.getItem(redirectAfterLoginKey);
};

export const removeRedirectAfterLogin = () => {
  localStorage.removeItem(redirectAfterLoginKey);
};
